export default "https://cdn-static.gokick.com/assets/643951300d065933ed58add7baf5b7b086396c88/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";